/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {NgControl} from '@angular/forms';
import {ConfirmationDialogModel} from '../confirmation-dialog.model';

@Component({
  selector: 'well-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  @Input() ngControl: NgControl | undefined = undefined;
  @Input() dialogData: ConfirmationDialogModel | undefined = undefined;

  isVisible: boolean | undefined = undefined;

  ngOnInit() {
    this.isVisible = true;
  }

  defaultHideDialog() {
    if (this.dialogData?.cancelCallback != null && this.ngControl) {
      this.dialogData.cancelCallback(this.ngControl);
    }
    this.isVisible = false;
  }

  defaultAcceptDialog() {
    if (this.dialogData?.acceptCallback != null && this.ngControl) {
      this.dialogData.acceptCallback(this.ngControl);
    }
    this.isVisible = false;
  }

}
